import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");

export const loginFetch = createAsyncThunk("user/login", async (payload) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/login", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });
  const users = await response.json();
  return users;
});
export const verifyPassword = createAsyncThunk("user/verifyPassword", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/verifyPassword", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const user = await response.json();
  return user;
});
export const userAdded = createAsyncThunk("user/addUser", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/addUser", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const user = await response.json();
  return user;
});
export const fetchUsers = createAsyncThunk("user/fetchUsers", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/allUser", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    /* body: JSON.stringify({a: 1, b: 'Textual content'}) */
  });
  const users = await response.json();
  return users;
});

export const fetchSite= createAsyncThunk("user/fetchSite", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/allSite", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    /* body: JSON.stringify({a: 1, b: 'Textual content'}) */
  });
  const users = await response.json();
  return users;
});

export const getAllUserDelegue = createAsyncThunk("user/getAllUserDelegue", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/getAllUserDelegue", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    /* body: JSON.stringify({a: 1, b: 'Textual content'}) */
  });
  const users = await response.json();
  return users;
});

export const fetchUsersGrossiste = createAsyncThunk("user/fetchUsersGrossiste", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/getUsersGrossiste", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const users = await response.json();
  return users;
});

export const gtIframeUser = createAsyncThunk("user/gtIframeUser", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/gtIframeUser/"+action.id_line, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const users = await response.json();
  return users;
});

export const saveImageProfil = createAsyncThunk("user/saveImageProfil", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/saveImageProfil", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const users = await response.json();
  return users;
});

export const exportExcel = createAsyncThunk("planning/exportExcelTerritory", async (action) => {
  var annee = action.annee;
  const response = await fetch(Configuration.BACK_BASEURL + `user/exportExcelTerritory/${annee}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const users = await response.json();
  return users;
});
export const getTypeUser = createAsyncThunk("user/getTypeUser", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/getTypeUser/" + id, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const users = await response.json();
  return users;
});
export const getActivePere = createAsyncThunk("user/getActivePere", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/getActivePere", {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const users = await response.json();
  return users;
});
export const userGetById = createAsyncThunk("user/userGetById", async (id1) => {
  const id = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "user/getUser", {
    method: 'POST',
    headers: {
      'id': id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const userBase = await response.json();
  return userBase;
});
export const userGetByIdSite = createAsyncThunk("user/userGetByIdSite", async (id1) => {
  const id = id1;
  const response = await fetch(Configuration.BACK_BASEURL + "user/getUserSite", {
    method: 'POST',
    headers: {
      'id': id,
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const userBase = await response.json();
  return userBase;
});


export const getDetailUser = createAsyncThunk("user/getDetailUser", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/getDetailUser/" + id, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const user = await response.json();
  return user;
});

export const upadetConsentementUser = createAsyncThunk("user/upadetConsentementUser", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/upadetConsentementUser/", {
    method: 'Post',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)

  });
  const user = await response.json();
  return user;
});

export const verification = createAsyncThunk("user/verification", async () => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/verification", {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },

  });
  const userBase = await response.json();
  return userBase;
});
export const userChangeEtat = createAsyncThunk("user/changeEtat", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/changeEtat/" + id, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const rootBase = await response.json();
  return rootBase;
});

export const sendAccesUser = createAsyncThunk("user/sendAccesUser", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/sendAccesUser/" + id, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const rootBase = await response.json();
  return rootBase;
});

export const changePassword = createAsyncThunk(
  "user/changePassword",
  async (action) => {
    const response = await fetch(
      Configuration.BACK_BASEURL + "user/changePassword",
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(action),
      }
    );
    const rootBase = await response.json();
    return rootBase;
  }
);




export const verifEmail = createAsyncThunk("user/allUserForTestMail", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "user/allUserForTestMail", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const users = await response.json();
  return users;
});






const usersReduce = createSlice({
  name: "users",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {
    profilUpdated(state, action) {
      fetch(Configuration.BACK_BASEURL + "user/updateProfile", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token': token
        },
        body: JSON.stringify(action.payload)
      });
    },
    /* userChangeEtat(state, action) {
      const { id } = action.payload;
      fetch(Configuration.BACK_BASEURL + "user/changeEtat/"+id, {
        method: 'PUT',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-access-token':token
        },
        body: JSON.stringify(action.payload)
      });
    }, */
  },
  extraReducers: {
    [getDetailUser.pending]: (state, action) => {
      state.loading = true;
    },
    [getDetailUser.fulfilled]: (state, action) => {
      state.loading = false;
      state.users = [...state.entities, action.payload];
    },
    [getDetailUser.rejected]: (state, action) => {
      state.loading = false;
    },
  },
});

export const { profilUpdated } = usersReduce.actions;

export default usersReduce.reducer;
